import { render, staticRenderFns } from "./ResponsePart.vue?vue&type=template&id=3bddcd4c"
import script from "./ResponsePart.vue?vue&type=script&lang=ts"
export * from "./ResponsePart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports